import '@main';
import '@vendor/swiper/swiper-bundle.min.js';

u.importCSS('@vendor/swiper/swiper-bundle.min.css');

function updateFractionPagination(swiper: any, paginationNumSelector: string): void {
  const fractionEl = document.querySelector(paginationNumSelector) as HTMLElement;
  if (fractionEl) {
    fractionEl.textContent = `${swiper.realIndex + 1} / ${swiper.slides.length}`;
  }
}

// now-showing
const showingSwiper = new Swiper(".l-showing-swiper", {
  slidesPerView: 1,
  spaceBetween: 40,
  breakpoints: {
    1199: {
      slidesPerView: 2,
    }
  },
  navigation: {
    nextEl: ".j-showing-swiper-button-next",
    prevEl: ".j-showing-swiper-button-prev",
  },
  pagination: {
    el: ".j-showing-pagination-progressbar",
    type: "progressbar",
  },
  on: {
    init: (swiper) => {
      updateFractionPagination(swiper, '.j-swiper-pagination-number');
    },
    slideChange: (swiper) => {
      updateFractionPagination(swiper, '.j-swiper-pagination-number');
    },
  },
});

const itemTimerEls: HTMLDivElement[] = u.selectAll('.j-out-date-timer');

itemTimerEls.forEach((el) => {
  if (el.dataset.time) {
    el.style.display = 'block';

    let countDownDate = new Date(el.dataset.time).getTime();

    let timer = setInterval(function () {
      let now = new Date().getTime();
      let distance = countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      el.innerHTML = u.trans('app.film.out.date', days, hours, minutes);

      if (distance < 0) {
        clearInterval(timer);
        el.style.display = 'none';
      }
    }, 1000);
  }
});
